/**
 * Staff-to-staff DMs — the cockpit's Online Agents panel. Poll-based delivery
 * (the panel refreshes an open thread every few seconds); opening a thread
 * marks the peer's messages as read server-side.
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';
import type { AgentDm, AgentDmUnread } from '../../types';

export class AgentChatResource {
  constructor(private readonly http: HttpClient) {}

  /** Per-peer unread counts for the current staff user. */
  unread(): Promise<{ items: AgentDmUnread[] }> {
    return this.http.get(endpoints.agentChat.unread());
  }

  /** The two-way thread with a peer (oldest-first; also marks their messages read). */
  thread(peerId: string, limit = 50): Promise<{ items: AgentDm[] }> {
    return this.http.get(endpoints.agentChat.messages(peerId), { query: { limit } });
  }

  /** Send a DM to a peer agent. */
  send(peerId: string, body: string): Promise<AgentDm> {
    return this.http.post(endpoints.agentChat.messages(peerId), { body });
  }
}
